import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { formatKeyword, CONTEXTUAL_ENTITY_TYPE, getNewTextConfigByPermission } from '@bingads-webui-campaign/recommendation-core';
import { withContextualAttributeTemplate } from '@bingads-webui-campaign/recommendation-contextual-attribute';
import template from './blocked-keywords-column.pug';

export class BlockedKeywordsColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, deps, recommendationType }) {
    let helpId;

    const newConfig = getNewTextConfigByPermission(recommendationType, deps.permissions, 'column');

    if (newConfig && newConfig.BlockedKeywordsColumn) {
      helpId = newConfig.BlockedKeywordsColumn.helpId || undefined;
    }

    super({
      name: 'blockedKeywordList',
      property: 'Opportunities/BlockedKeywordList',
      title: i18n.getString('Details_View_Blocked_Keywords') || '__Blocked keywords__',
      bodyClasses: ['grid-column-blockedKeywordList'],
      colClasses: ['col-superLongText'],
      type: 'string',
      helpId,
    });
    this.i18n = i18n;
  }

  template({ value: { OpportunityId, BlockedKeywordList, TotalBlockedKeywordCount } }) {
    const { i18n } = this;
    const maxShowCount = 3;
    const blockedKeywordList =
      _.map(_.first(BlockedKeywordList, maxShowCount), keyword => withContextualAttributeTemplate({
        opportunityId: OpportunityId,
        entityName: formatKeyword(keyword.Keyword, keyword.MatchTypeId),
        entityId: keyword.OrderItemId,
        entityType: CONTEXTUAL_ENTITY_TYPE.KEYWORD,
        status: 'false',
      })).join(', ');

    let result = blockedKeywordList;
    if (TotalBlockedKeywordCount > maxShowCount) {
      const more = ` +${i18n.getString('Recommendation_Grid_Todo_More', {
        count: TotalBlockedKeywordCount - maxShowCount,
      })}`;
      result = result.concat(more);
    }

    return template({ blockedKeywords: result });
  }

  get property() {
    return {
      get(item) {
        return _.chain(item.Opportunities).first().value();
      },
      key: 'Opportunities/BlockedKeywordList',
    };
  }
}
